import type { MetricDataPoint } from '@/lib/dashboard.ts';

/** A funnel step is the whole period's total, not the latest snapshot. */
export function sumPoints(points: MetricDataPoint[]): number {
  return points.reduce((total, point) => total + Number(point.value), 0);
}

/** A share, or a dash where there is no denominator to divide by. */
export function formatPct(numerator: number, denominator: number): string {
  return denominator === 0 ? '–' : `${Math.round((numerator / denominator) * 100)}%`;
}
